import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import React, { ReactElement, useState } from "react";
import { useNavigate } from "react-router";
import { DropdownLegacy, DropdownLegacyElement } from "../../../components";
import { useQueryCache } from "../../../hooks/api/v2/queryCache";
import { useFirebaseUser } from "../../../hooks/useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { getOrderAcceptRedirectUrl } from "../helpers/AcceptOrdersHelper/getOrderAcceptRedirectUrl";
import { isPaidCheckoutOrder } from "../../../utils/sellarHelpers";
import { CancelOrderDialog } from "../modals/CancelOrderDialog";
import { SellarCreditCancelWarningDialog } from "../modals/SellarCreditCancelWarningDialog";

export function RequestedOrderDropdownList({
  order,
}: {
  order: OrderGetResponseType;
}): ReactElement | null {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryCache = useQueryCache();
  const navigate = useNavigate();
  const [cancelOrderDialogActive, setCancelOrderDialogActive] =
    useState<boolean>(false);
  const [sellarCreditCancelWarningActive, setSellarCreditCancelWarningActive] =
    useState<boolean>(false);
  const onSubmit = () => {
    const redirectUrl = getOrderAcceptRedirectUrl({
      queryCache,
      orderId: order.id,
      uid: user?.uid,
      businessId: business?.id,
    });

    navigate(redirectUrl);
  };
  const cancelOrderText = isPaidCheckoutOrder({
    paidAt: order.paidAt,
    paymentType: order.paymentType,
  })
    ? "Cancel & Refund"
    : "Cancel order";

  const showCancelFlow = () => {
    if (order.paymentType === "sellarCredit") {
      setSellarCreditCancelWarningActive(true);
    } else {
      setCancelOrderDialogActive(true);
    }
  };

  return (
    <>
      <DropdownLegacy className={"print:hidden"}>
        <DropdownLegacyElement
          className={"text-red-500"}
          onClick={showCancelFlow}
        >
          {cancelOrderText}
        </DropdownLegacyElement>
      </DropdownLegacy>
      <SellarCreditCancelWarningDialog
        active={sellarCreditCancelWarningActive}
        type={"supplier"}
        onDismiss={() => {
          setSellarCreditCancelWarningActive(false);
        }}
        onConfirmCancel={() => {
          setSellarCreditCancelWarningActive(false);
          setCancelOrderDialogActive(true);
        }}
      />
      <CancelOrderDialog
        active={cancelOrderDialogActive}
        order={order}
        onDismiss={() => setCancelOrderDialogActive(false)}
        onSubmit={onSubmit}
      />
    </>
  );
}
